export default function Hero() {
  return (
    <section id="home" className="min-h-screen flex items-center justify-center bg-purple-light text-purple-900">
      <div className="text-center px-4 sm:px-6 max-w-5xl mx-auto">
        <div className="mb-8">
          <div className="w-24 h-24 mx-auto mb-6 bg-blue-600 rounded-full flex items-center justify-center text-3xl font-bold shadow-xl">
            <svg className="w-12 h-12 text-white" fill="currentColor" viewBox="0 0 24 24">
              <path d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0L19.2 12l-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"/>
            </svg>
          </div>
        </div>
        <h1 className="text-3xl sm:text-5xl md:text-6xl font-bold mb-6 text-gray-900">
          Hey, I'm <span className="text-blue-600">Tej</span>
        </h1>
        <p className="text-lg sm:text-xl md:text-2xl mb-6 text-gray-700 font-light">
          Developer & Content Creator
        </p>
        <p className="text-base sm:text-lg mb-8 sm:mb-12 text-gray-600 max-w-3xl mx-auto leading-relaxed">
          I enjoy building creative projects with code, sharing my journey, and always learning something new.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center">
          <a href="#projects" className="px-6 sm:px-8 py-3 sm:py-4 bg-blue-600 text-white hover:bg-blue-700 rounded-lg font-semibold transition-colors duration-300 text-sm sm:text-base">
            Check Out My Work
          </a>
          <a href="#contact" className="px-6 sm:px-8 py-3 sm:py-4 border-2 border-blue-600 text-blue-600 rounded-lg font-semibold hover:bg-blue-600 hover:text-white transition-colors duration-300 text-sm sm:text-base">
            Say Hello
          </a>
        </div>
      </div>
    </section>
  );
}
